export enum ServicesEnum {
    Registration = 1,
    ExternalRegistration,
    MemberPortal,
    Job,
}